import {RETRIEVE_SETTING_INFO} from '@/api'
import {UPDATE_SCHOOL_SETTINGS} from '@/api'
import {RETRIEVE_SYSTEM_INFO} from '@/api'

export default {
  retrieveSettingInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.school_info) {
        commit('retrieveSettingInfo', {settingInfo: response.data.data.school_info})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_SETTING_INFO({}, successCallback, errorCallback)
  },

  updateSchoolSetting({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.school_info) {
        commit('retrieveSettingInfo', {settingInfo: response.data.data.school_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    UPDATE_SCHOOL_SETTINGS({data: payload.data}, successCallback, errorCallback)
  },

  getSystemInfo({commit}, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.system_info) {
        commit('retrieveSystemInfo', {systemInfo: response.data.data.system_info})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_SYSTEM_INFO({}, successCallback, errorCallback)
  }

};
